// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digim-card-title-hour-text {
  display: block;
  font-size: 1rem;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
  margin: 15px 0;
  font-weight: 600;
}

.digim-text-card-title-small {
  display: block;
  font-size: 32px;
  width: 100%;
  color: var(--color-black-light);
  text-align: center;
  font-family: Calibri;
}

.widget-content-row ion-grid {
  height: 100%;
  align-items: center;
}
.widget-content-row ion-grid ion-row {
  align-items: center;
}
.widget-content-row ion-grid ion-row ion-col ion-text {
  margin: 0;
}

.blue-80 {
  border-bottom: 2px solid var(--color-blue-2-light);
  width: 80%;
  margin: auto;
}

.digim-button-clock-in {
  --background: var(--color-blue-1-light);
  font-weight: lighter;
  height: 35px;
  width: 120px;
  text-transform: capitalize;
  --border-color: var(--color-blue-1-dark);
  --border-style: solid;
  --border-width: 2px;
  --padding-start: 0;
  --padding-end: 0;
}
.digim-button-clock-in ion-icon {
  width: 20px;
  height: 20px;
}

.digim-button-clock-out {
  --background: var(--color-red-light);
  font-weight: lighter;
  height: 35px;
  width: 120px;
  text-transform: capitalize;
  --border-color: var(--color-red-dark);
  --border-style: solid;
  --border-width: 2px;
  --padding-start: 0;
  --padding-end: 0;
}
.digim-button-clock-out ion-icon {
  width: 20px;
  height: 20px;
}

/* dark theme styles */
.dark .digim-card-title-hour-text {
  color: var(--color-black-dark);
}
.dark .digim-text-card-title-small {
  color: var(--color-black-dark);
}
.dark .blue-80 {
  border-bottom: 2px solid var(--color-blue-2-dark);
}
.dark .digim-button-clock-in {
  --background: var(--color-blue-1-dark);
  --border-color: var(--color-blue-1-light);
}
.dark .digim-button-clock-out {
  --background: var(--color-red-dark);
  --border-color: var(--color-red-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/widgets/timeclock-widget/timeclock-widget.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/widgets/timeclock-widget/timeclock-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;ACCF;;ADEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,oBAAA;ACCF;;ADGE;EACE,YAAA;EACA,mBAAA;ACAJ;ADCI;EACE,mBAAA;ACCN;ADEQ;EACE,SAAA;ACAV;;ADOA;EACE,kDAAA;EACA,UAAA;EACA,YAAA;ACJF;;ADOA;EACE,uCAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACJF;ADME;EACE,WAAA;EACA,YAAA;ACJJ;;ADQA;EACE,oCAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,qCAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ACLF;ADOE;EACE,WAAA;EACA,YAAA;ACLJ;;ADSA,sBAAA;AAEE;EACE,8BAAA;ACPJ;ADUE;EACE,8BAAA;ACRJ;ADWE;EACE,iDAAA;ACTJ;ADYE;EACE,sCAAA;EACA,yCAAA;ACVJ;ADaE;EACE,mCAAA;EACA,sCAAA;ACXJ","sourcesContent":[".digim-card-title-hour-text {\r\n  display: block;\r\n  font-size: 1rem;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n  margin: 15px 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.digim-text-card-title-small {\r\n  display: block;\r\n  font-size: 32px;\r\n  width: 100%;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  font-family: Calibri;\r\n}\r\n\r\n.widget-content-row {\r\n  ion-grid {\r\n    height: 100%;\r\n    align-items: center;\r\n    ion-row {\r\n      align-items: center;\r\n      ion-col {\r\n\r\n        ion-text {\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.blue-80 {\r\n  border-bottom: 2px solid var(--color-blue-2-light);\r\n  width: 80%;\r\n  margin: auto;\r\n}\r\n\r\n.digim-button-clock-in {\r\n  --background: var(--color-blue-1-light);\r\n  font-weight: lighter;\r\n  height: 35px;\r\n  width: 120px;\r\n  text-transform: capitalize;\r\n  --border-color: var(--color-blue-1-dark);\r\n  --border-style: solid;\r\n  --border-width: 2px;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n\r\n  ion-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n.digim-button-clock-out {\r\n  --background: var(--color-red-light);\r\n  font-weight: lighter;\r\n  height: 35px;\r\n  width: 120px;\r\n  text-transform: capitalize;\r\n  --border-color: var(--color-red-dark);\r\n  --border-style: solid;\r\n  --border-width: 2px;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n\r\n  ion-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n/* dark theme styles */\r\n.dark {\r\n  .digim-card-title-hour-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-text-card-title-small {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .blue-80 {\r\n    border-bottom: 2px solid var(--color-blue-2-dark);\r\n  }\r\n  \r\n  .digim-button-clock-in {\r\n    --background: var(--color-blue-1-dark);\r\n    --border-color: var(--color-blue-1-light);\r\n  }\r\n  \r\n  .digim-button-clock-out {\r\n    --background: var(--color-red-dark);\r\n    --border-color: var(--color-red-light);\r\n  }\r\n}\r\n",".digim-card-title-hour-text {\n  display: block;\n  font-size: 1rem;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n  margin: 15px 0;\n  font-weight: 600;\n}\n\n.digim-text-card-title-small {\n  display: block;\n  font-size: 32px;\n  width: 100%;\n  color: var(--color-black-light);\n  text-align: center;\n  font-family: Calibri;\n}\n\n.widget-content-row ion-grid {\n  height: 100%;\n  align-items: center;\n}\n.widget-content-row ion-grid ion-row {\n  align-items: center;\n}\n.widget-content-row ion-grid ion-row ion-col ion-text {\n  margin: 0;\n}\n\n.blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-light);\n  width: 80%;\n  margin: auto;\n}\n\n.digim-button-clock-in {\n  --background: var(--color-blue-1-light);\n  font-weight: lighter;\n  height: 35px;\n  width: 120px;\n  text-transform: capitalize;\n  --border-color: var(--color-blue-1-dark);\n  --border-style: solid;\n  --border-width: 2px;\n  --padding-start: 0;\n  --padding-end: 0;\n}\n.digim-button-clock-in ion-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.digim-button-clock-out {\n  --background: var(--color-red-light);\n  font-weight: lighter;\n  height: 35px;\n  width: 120px;\n  text-transform: capitalize;\n  --border-color: var(--color-red-dark);\n  --border-style: solid;\n  --border-width: 2px;\n  --padding-start: 0;\n  --padding-end: 0;\n}\n.digim-button-clock-out ion-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* dark theme styles */\n.dark .digim-card-title-hour-text {\n  color: var(--color-black-dark);\n}\n.dark .digim-text-card-title-small {\n  color: var(--color-black-dark);\n}\n.dark .blue-80 {\n  border-bottom: 2px solid var(--color-blue-2-dark);\n}\n.dark .digim-button-clock-in {\n  --background: var(--color-blue-1-dark);\n  --border-color: var(--color-blue-1-light);\n}\n.dark .digim-button-clock-out {\n  --background: var(--color-red-dark);\n  --border-color: var(--color-red-light);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
